/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCosh } from '../../factoriesAny.js';
export var coshDependencies = {
  typedDependencies,
  createCosh
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesCosh.generated.js
// module id = null
// module chunks = 